<template>
  <suspense>
    <div class="website-main">
      <component :is="layoutComponent"> </component>
    </div>
  </suspense>
</template>

<script setup>
import layoutComponent from './layouts/website/Index.vue';
</script>
<style>
@import url('@/styles/components/website-base.css');
@import url('@/styles/components/element-plus.css');
@import url('@/styles/animations/index.css');
.website-main {
  background-color: #fff;
}
</style>
